import { Axis } from '../axis';
import { DrawPass } from '../chart';
import { ChartFeature, RectangleLayerSpecification } from '../chart-props';

export function drawRectangleLayer(
    pass: DrawPass,
    features: ChartFeature[],
    layer: RectangleLayerSpecification,
    xAxis: Axis,
    yAxis: Axis
) {
    for (let i = 0; i < features.length; i++) {
        const feature = features[i];
        if (layer.filter && !layer.filter(feature, i)) {
            continue;
        }

        if (feature.geometry.type !== 'Polygon') {
            continue;
        }

        pass.drawer.drawPolygon(
            feature.geometry.coordinates.map(([x, y]) => [xAxis.project(x, pass.viewState), yAxis.project(y, pass.viewState)]),
            {
                color: layer.paint.fill
            },
            {
                width: layer.paint.outlieWidth ?? 0,
                color: layer.paint.outlineColor ?? layer.paint.fill
            }
        );
    }
}
